const SortArrowIcon = ({ direction = 'asc' }: { direction: 'asc' | 'desc' }) => {
  const rotation = direction === 'asc' ? 'rotate(0)' : 'rotate(180deg)';
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      style={{ transform: rotation, transition: 'transform 0.2s ease-in-out' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4v16M12 20l-6-6M12 20l6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortArrowIcon;
